export default [{
    path: '/node/cityNode',
    name: 'cityNode',
    meta: {
      index: 15
    },
    component: () => import('@/views/node/cityNode.vue')
  }]
  